
let lang = localStorage.getItem('i18n-lang')||'eu';
console.log(lang,"-----------获取当前语言")
export default {
	// baseUrl: lang=='zh'?'http://ah_api_website.wsj.xinzhidi.cn':'http://ah_api_website_en.wsj.xinzhidi.cn',
	// baseUrl: lang=='zh'?'http://www_api_cn.aohua.com':'http://www_api_en.aohua.com',
	// baseUrl: lang=='zh'?'https://wwwapicn.aohua.com':lang=='en'?'https://wwwapien.aohua.com':'https://gwapi.wangsjtest.cn',
	baseUrl: lang=='zh'?'https://wwwapicn.aohua.com':lang=='en'?'https://wwwapien.aohua.com':'https://wwwapieu.aohua.eu',
}